import api from './index.js'

export const fetchBatchWorks = async (
    id,
  currentPage,
  pageSize,
  params,
  sortColumn,
  sortDirection
) => {
  try {
    const queryParams = new URLSearchParams(params).toString() // Convert params object to query string
    const response = await api.get(
      `/admin/batch-work/${id}/?pageNumber=${currentPage}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&${queryParams}`
    )

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch batch-logs')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch batch-logs')
  }
}

